/** Shared by Overview and Reports so the choice stays in sync. */
export const INCLUDE_OFF_BUDGET_STORAGE_KEY = "reports.includeOffBudget";

export function readIncludeOffBudgetFromStorage(): boolean {
  try {
    const v = localStorage.getItem(INCLUDE_OFF_BUDGET_STORAGE_KEY);
    if (v === null) return true;
    return v === "1" || v === "true";
  } catch {
    return true;
  }
}

export function writeIncludeOffBudgetToStorage(value: boolean): void {
  try {
    localStorage.setItem(INCLUDE_OFF_BUDGET_STORAGE_KEY, value ? "1" : "0");
  } catch {
    /* ignore */
  }
}
